import fetcher_v2 from "../fetcher_v2";
import { URLS } from "../urls";

export type CompanyInfoResponse = {
  company_name: string;
  full_company_name?: string;
  company_description: string;
};

export const getCompanyInfo = async (url: string) => {
  return fetcher_v2<
    CompanyInfoResponse,
    { url: string },
    { detail: { message: string } }
  >(URLS.COMPANY_INFO, {
    body: {
      url,
    },
    timeout: 30000,
  });
};
